import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Tooltip(theme: Theme) {
  const isLight = theme.palette.mode === 'light'

  return {
    MuiTooltip: {
      defaultProps: {
        // Non-interactive by default: the popper keeps `pointer-events: none`, so a tooltip
        // hovering over a list can't swallow scrolls or hide the link underneath it. No tooltip
        // in the app has clickable content; one that gets it must opt out per instance.
        disableInteractive: true,
      },
      styleOverrides: {
        popper: {
          zIndex: 2000000001,
        },
        tooltip: {
          backgroundColor: theme.palette.grey[isLight ? 800 : 700],
        },
        arrow: {
          color: theme.palette.grey[isLight ? 800 : 700],
        },
      },
    },
  }
}
